import React from "react";
import AccessPending from "./AccessPending";
import { useEntitlements } from "../entitlements/EntitlementContext";
import { hasMsiOperatorAccess } from "../msiOperatorAccess";

export default function MSIOperatorRoute({ children }) {
  const entitlement = useEntitlements();
  if (entitlement.loading || entitlement.accessState === "checking") {
    return <AccessPending feature="MSI Operator" state="checking" />;
  }
  if (!hasMsiOperatorAccess(entitlement)) {
    return <AccessPending feature="MSI Operator" reason="This private operator workspace is not available for this account." />;
  }
  return children;
}

